import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import { IDownloadNFEResponse } from '../../store/ducks/long-steel-orders/types';

export class DownloadAreaService extends EGerdauService {
  async loadNFXMLDownloadFile(
    billingNumber: string
  ): Promise<IDownloadNFEResponse> {
    const headers = new EGerdauService().getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.GENERATE_NF_XML}?billingNumber=${billingNumber}`,
      { headers }
    );
    return response.data as IDownloadNFEResponse;
  }
}
